import { CompanyConfig } from 'types';

export let config: CompanyConfig;

if (typeof window === 'undefined') {
  config = {} as CompanyConfig;
}

export const apiBaseUrl = process.env.NEXT_PUBLIC_API_ENDPOINT || '/api'

export async function loadConfig() {
  try {
    config = await fetch(`${apiBaseUrl}/config`).then(r => r.json());
  } catch (e) {
    console.error('Error loading app configuration', e);
  }
}
